function initElReviews(section) {
  if (!section || section.dataset.elReviewsInitialized === 'true') return;
  section.dataset.elReviewsInitialized = 'true';

  const items = section.querySelectorAll('[data-review-item]');
  const button = section.querySelector('[data-reviews-toggle]');

  if (!items.length || !button) return;

  const mobileMedia = window.matchMedia('(max-width: 991px)');

  const getVisibleCount = () => {
    return mobileMedia.matches ? 3 : 6;
  };

  const hideItem = (item) => {
    item.classList.add('el-reviews__item--hidden');

    setTimeout(() => {
      if (item.classList.contains('el-reviews__item--hidden')) {
        item.style.display = 'none';
      }
    }, 300);
  };

  const showItem = (item) => {
    item.style.display = 'flex';

    requestAnimationFrame(() => {
      item.classList.remove('el-reviews__item--hidden');
    });
  };

  const updateCollapsedState = () => {
    const visibleCount = getVisibleCount();
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    items.forEach((item, index) => {
      if (isExpanded || index < visibleCount) {
        showItem(item);
      } else {
        hideItem(item);
      }
    });

    if (items.length <= visibleCount) {
      button.style.display = 'none';
    } else {
      button.style.display = '';
    }

    button.textContent = isExpanded ? 'Less Reviews' : 'More Reviews';
  };

  button.addEventListener('click', () => {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!isExpanded));
    updateCollapsedState();
  });

  if (mobileMedia.addEventListener) {
    mobileMedia.addEventListener('change', updateCollapsedState);
  } else {
    mobileMedia.addListener(updateCollapsedState);
  }

  updateCollapsedState();
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.el-reviews').forEach(initElReviews);
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.el-reviews');
  if (section) {
    initElReviews(section);
  }
});